'use client';

import { useRutilusQuery } from '../../../api/graphql/useRutilusQuery';
import { GQLFollowButton } from '../../../components/Clickables/Buttons/GQLFollowButton';
import { useUserInfo } from '../../../helpers/hooks/useUserInfo';
import {
  FollowRecordsTypeEnum,
  GetBrandIsFollowed,
  GetBrandIsFollowedVariables,
} from '../../../interfaces/graphql';
import { getBrandIsFollowed } from '../../../queries/rutilus/Brands';

export const PageFollowButton = ({
  pageId,
  displayName,
}: {
  pageId: string;
  displayName: string;
}) => {
  const { isLoggedIn } = useUserInfo();
  const { data: followData, loading } = useRutilusQuery<
    GetBrandIsFollowed,
    GetBrandIsFollowedVariables
  >(getBrandIsFollowed, {
    variables: { externalId: pageId },
    skip: !isLoggedIn,
  });
  const followedByCurrentUser = followData?.entry.followedByCurrentUser ?? false;

  const showFollowButton = !isLoggedIn || (!loading && followData);

  if (!showFollowButton) {
    return <></>;
  }

  return (
    <GQLFollowButton
      source="brand-follow-button"
      isFollowed={followedByCurrentUser}
      id={pageId}
      type={FollowRecordsTypeEnum.PAGE}
      buttonProps={{ className: 'w-full', style: { borderRadius: 0 } }}
      customAppDownloadHeader={`Download the Fishbrain app to follow ${displayName}`}
    />
  );
};
